module.exports = __webpack_public_path__ + "img/1.f84267d7.jpg";